import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { scrollTop, setLenis } from "@/lib/scroll";
import Landing from "@/pages/Landing";
import Order from "@/pages/Order";
import CheckoutResult from "@/pages/CheckoutResult";
import Login from "@/pages/Login";
import Clock from "@/pages/Clock";
import Kds from "@/pages/Kds";
import Admin from "@/pages/admin/Admin";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center bg-sage font-display text-lg font-semibold text-artichoke">
        Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf = 0;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Toaster richColors position="top-center" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/order" element={<Order />} />
          <Route path="/checkout/success" element={<CheckoutResult success />} />
          <Route path="/checkout/failure" element={<CheckoutResult />} />
          <Route path="/login" element={<Login />} />
          <Route path="/clock" element={<Clock />} />
          <Route path="/kds" element={<Kds />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
